/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';

import PropTypes from 'prop-types';
import {Button, Panel, Grid, Row, Col} from 'eui-components';

/**
 * Displays a page header with the current context institution.  Provides a button for changing the current
 * context institution.
 * @param props component props.
 * @returns {XML} JSX used to render the ccomponent.
 * @constructor
 */
const InstitutionHeader = (props) => {
  const handleClick = (event) => {
    event.preventDefault();
    event.currentTarget.blur();
    props.onChangeInstitution();
  };

  const { institution } = props;

  return (
    <Panel id={'sc-institution-header'}>
      <Panel.Body>
        <Grid fluid={true}>
          <Row>
            <Col md={11} sm={10}>
              <div id={'institution-header-name'}>
                {institution ? `${institution.name} (${institution.id})` : 'No institution selected'}
              </div>
            </Col>
            <Col md={1} sm={2}>
              <Button bsSize="small" onClick={handleClick} id='institution-header-show-institution-picker'>
                <FormattedMessage id="InstitutionHeader.changeInstitutionButton" defaultMessage='Change'/>
              </Button>
            </Col>
          </Row>
        </Grid>
      </Panel.Body>
    </Panel>
  );
};

/**
 * Validation of property types.
 */
InstitutionHeader.propTypes = {
  institution: PropTypes.object,
  onChangeInstitution: PropTypes.func.isRequired
};

export default injectIntl(InstitutionHeader);



// WEBPACK FOOTER //
// ./src/InstitutionHeader/InstitutionHeader.js